export const crudMessage = {
	create: {
		title: "New message",
		subtitle: {
			sms:
				"Enter the content that will be sent to the selected customer list. Your message will impact ",
			whatsapp:
				"Select a template based on what you want to communicate and then change its parameters.",
		},
		client: "person",
		clients: "people",
		mes: "Click here to see hints about the content",
		subtitleTemplateList:
			"Select a template based on what you want to communicate and then change its parameters.",
	},
	edit: {
		title: "Edit Scheduled Message",
		subtitle: "Rewrite the message content or change the sending schedule.",
	},
	summarizes: "Shipping data",
	content: "Message Content",
	program: "Schedule shipping",
	sendNow: "Send Now",
	textArea: {
		content: "Message Content",
		copy: "Copy message content",
		successCopy: "Message copied to clipboard",
		at: "at",
		placeholder: "Write the message content for the selected group...",
		character: "remaining character",
		characters: "characters remaining",
		footer:
			"Tip: To add variables and be able to change them in the future, type [VARIABLE] in square brackets.",
	},
	resumeCard: {
		sms: "SMS",
		footerText: {
			summarizes: "Messages to opt-out customers will not be charged.",
			smsBalanceAddedValue:
				"The extra value of {{value}} will be added to Zig's monthly charge payment.",
			smsBalanceSubtractedValue:
				"The value of {{value}} will be deducted from Zig's monthly charge payment.",
			noExtraCost:
				"As there was no change in the amount of the recipient list, there will be no extra cost.",
			charactersLimit:
				"Character count has exceeded the limit. The SMS cost has been changed and the value of {{value}} will be added to Zig's monthly charge payment.",
			addedValue: "The value of {{value}} will be added to Zig's monthly charge payment.",
		},
		messageCost: "Shipping Cost",
		amountMessageSent: "Total recipients",
		rescheduledShippingCost: "Rescheduled Shipping Cost",
		postShipmentBalance: "Post Shipment Balance",
		messageInProcess: {
			sms: "SMS in process",
			whatsapp: "Message in process",
		},
		amountMessageReceived: {
			sms: "SMS received",
			whatsapp: "received messages",
		},
		resume: "Submission summary",
		amountMessageNotReceived: {
			notRecieved: {
				sms: "SMS not received",
				whatsapp: "messages not received",
			},
			optout: {
				sms: "SMS not received by optout",
				whatsapp: "messages not received by optout",
			},
			error: {
				sms: "SMS not received by error",
				whatsapp: "messages not received by error",
			},
		},
	},
	modalMessage: {
		title: {
			messageSent: "Message sent",
			messageScheduled: "Scheduled message",
			messageTips: "Message Tips",
		},
		messageScheduled: {
			clientsCount: "Your message will be sent to ",
			client: "client",
			clients: "clients",
			of: "of",
			day: "day",
			at: "at",
			cancelOrEdit:
				"If you want to unsubscribe or change the content, go back to the message list and edit the shipping information.",
		},
		messageSent: {
			clientsCount: "Your message was sent to ",
			client: "client",
			clients: "clients",
			of: "of",
		},
		messageTips: {
			tips: "Tips of what you can do",
			typeOne:
				"A well-written message impacts your customers in a unique way! As you have {{characters}} characters, ideally your message is succinct, clear and direct.",
			tipTwo:
				"You can include important links for your customers. Links to your landing page or event ticket make it easier for the customer to access information and purchase tickets.",
			tipThree:
				"Is there going to be an interesting promotion? Filter the group of customers who are entitled to the promotion and send targeted SMS.",
			tipFour:
				"Launch of a new product? Filter your best customers and send all your product information.",
		},
		addBalance: "Add Balance",
		notBalance:
			"You don't have enough balance to send SMS to the selected group. Do you want to add the remaining balance?",
	},
	campaignSelect: {
		title: "Campaign",
		placeholder: "Select campaign",
		createOrSearch: "Search by campaign or create a new one",
		text:
			"OPTIONAL: Link this send to a campaign to make it easier to analyze the performance of multiple sends together.",
	},
	campaignModal: {
		title: "Campaign name",
		tooltipMessage:
			"OPTIONAL: Link this send to a campaign to make it easier to analyze the performance of multiple sends together.",
		placeholder: "Enter the campaign name",
		confirmButton: "Create campaign",
	},
	campaignsDetail: {
		columns: {
			clientName: "Client Name",
			gender: "Gender",
			cpf: "CPF",
			status: "Status",
			phone: "Phone",
		},
		genders: {
			male: "Man",
			female: "Woman",
			other: "Other",
			uninformed: "Not informed",
		},
		sent: "Sent",
		canceled: "Cancelled",
		sentInDay: "Sent on the day {{day}} to",
		clients: "clients",
		client: "client",
		programmedMessage: "Your message was scheduled on {{day}} to be sent on {{date}}",
		canceledMessage: "The message that was supposed to be sent on {{day}} was cancelled",
	},
	day: "Day",
	hour: "Hour",
	footer: {
		reprogram: "Reprogram SMS sending",
		scheduleShipping: "Schedule SMS sending",
		send: "Send SMS now",
	},
	success: {
		createTemplate: "New template requested",
	},
	errors: {
		smsCost: "SMS cost needs to be configured",
		place: "Could not identify place",
		campaign: "Unable to create campaign.",
		editMessage: {
			sendNow: "Data updated. Message will be sent shortly.",
			success: "Data updated.",
		},
	},
};
